import styled from 'styled-components'
import PropTypes from 'prop-types'
import medias from '../../../util/medias'

const DEFAULT_RADIUS = 4

const Paper = styled.div`
  padding: 32px 56px 24px 56px;
  border-top-left-radius: ${props => props.borderTopLeftRadius}px;
  border-top-right-radius: ${props => props.borderTopRightRadius}px;
  border-bottom-right-radius: ${props => props.borderBottomRightRadius}px;
  border-bottom-left-radius: ${props => props.borderBottomLeftRadius}px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(153, 153, 153, 0.2);
  ${medias.small`padding: 32px 16px 24px 16px;`}
`

Paper.propTypes = {
  borderTopLeftRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borderTopRightRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borderBottomRightRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borderBottomLeftRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

Paper.defaultProps = {
  borderTopLeftRadius: DEFAULT_RADIUS,
  borderTopRightRadius: DEFAULT_RADIUS,
  borderBottomRightRadius: DEFAULT_RADIUS,
  borderBottomLeftRadius: DEFAULT_RADIUS,
}

export default Paper
